/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import ModalCalendarEvent from "../../pages/Calendar/ModalCalendarEvent";
import AlertListTable from "./alertsListTable";
import AlertEdit from "./alertModal";

import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

const AlertList = ({ alerts, setAlerts, novedades, novedadId = null, withPaging, withClientData }) => {
  const { currentUser } = useAuth();
  const [alertSelected, setAlertSelected] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const isAdmin = currentUser.haveAdminAccess(modulos.CALENDAR);
  const isAudit = currentUser.haveAuditAccess(modulos.CALENDAR);

  const handleToggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleClickAlert = (alert) => {
    setAlertSelected(alerts.find((el) => el.id === alert.id));
    handleToggleModal();
  };

  const newAlertUpdated = (updatedAlert) => {
    setIsOpenModal(false);
    const elementIndex = alerts.findIndex((alert) => alert.id === updatedAlert.id);
    const orderedAlertsNew = [...alerts];
    orderedAlertsNew[elementIndex] = updatedAlert;
    setAlerts(orderedAlertsNew);
  };

  return (
    <div>
      <ModalCalendarEvent centered modalTitle="Detalle Alerta" handleIsOpenModal={isOpenModal} handleToggleModal={handleToggleModal}>
        {alertSelected && (
          <AlertEdit
            noEdit
            alertSelected={alertSelected}
            newTaskUpdated={newAlertUpdated}
            isAdmin={isAdmin}
            isAudit={isAudit}
            isLider={currentUser.user.Pi.itemId === alertSelected.liderId}
          />
        )}
      </ModalCalendarEvent>
      <div>
        <AlertListTable
          alerts={alerts}
          novedades={novedades}
          newAlertUpdated={newAlertUpdated}
          handleClickAlert={handleClickAlert}
          withPaging={withPaging}
          withClientData={withClientData}
        />
        {/* {isAdmin && novedadId ? (
                <div className="todo-list-footer">
                  <div className="add-task-btn-wrapper">
                    <span className="add-task-btn">
                      <button type="button" className="btn btn-primary" onClick={() => handleClickNewAlert()}>
                        + Crear Alerta
                      </button>
                    </span>
                  </div>
                </div>
              ) : (
                <></>
              )} */}
      </div>
    </div>
  );
};

export default AlertList;
